import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=5a9302bc&scoped=true&"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=5a9302bc&lang=scss&scoped=true&"
import style1 from "./IndexAsideStatic.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9302bc",
  null
  
)

export default component.exports